export enum BackendTools {
  ExecuteQuery = 'execute_query',
  LdsGeocode = 'lds_geocode',
  AsyncWorkflowJobGetResults = 'async_workflow_job_get_results',
  GenerateChart = 'generate_chart'
}
